import { render } from "./PwaMobile.vue?vue&type=template&id=72f3e254&scoped=true"
import script from "./PwaMobile.vue?vue&type=script&lang=js"
export * from "./PwaMobile.vue?vue&type=script&lang=js"

import "./PwaMobile.vue?vue&type=style&index=0&id=72f3e254&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f3e254"]])

export default __exports__